import { FC } from 'react';
import { Box, Image, Stack } from '@chakra-ui/react';
import { RTBlockNode } from '@prismicio/types';

import { ToolboxOffer } from '__generated__/GQL';
import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import Text from 'components/_core/Text';
import PrismicRichText from 'components/PrismicRichText';

import locales from './locales';

type PartnerCardProps = {
  partner: NonNullable<ToolboxOffer['partner']>;
};

const PartnerCard: FC<PartnerCardProps> = ({ partner }) => (
  <Card padding="space-24">
    {partner.logo ? (
      <Box paddingBottom="space-16">
        <Image
          alt={`${partner.name} logo`}
          borderRadius="radius-full"
          boxSize="40px"
          objectFit="cover"
          src={partner.logo}
        />
      </Box>
    ) : null}

    <Box paddingBottom="space-24">
      <Stack spacing="0">
        <Text fontWeight="weight-500" size="lg" variant="primary">
          {partner.name}
        </Text>

        <Text variant="light">{partner.catchline}</Text>
      </Stack>
    </Box>

    {partner.description ? (
      <Text size="sm">
        <PrismicRichText richText={partner.description as RTBlockNode[]} />
      </Text>
    ) : null}

    {partner.name && partner.link ? (
      <Box paddingTop="space-24">
        <Button
          as="a"
          href={partner.link}
          icon="link"
          target="_blank"
          variant="inline-primary"
        >
          {
            locales.formatString(locales.knowMore, {
              partnerName: partner.name,
            }) as string
          }
        </Button>
      </Box>
    ) : null}
  </Card>
);

export default PartnerCard;
